import { Theme } from "@mui/material/styles";

export const useStyle = (theme: Theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
  },
  paper: {
    padding: 2,
    display: "flex",
    flexDirection: "column",
    gap: 2,
    width: "100%",
    height: "fit-content",
  },
  boxHeader: {
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    height: "fit-content",
    width: "100%",
    alignItems: { xs: "start", md: "center" },
    gap: 1,
  },
  boxSearchAndFilter: {
    display: "flex",
    width: "100%",
    flexDirection: { xs: "column", lg: "row" },
    gap: 2,
  },
  button: {
    height: "40px",
    transition: "opacity 0.5s, background-color 0.5s, filter 0.5s, color 0.5s",
    opacity: 1,
  },
  searchInput: {
    width: { xs: "100%", sm: "325px" },
  },
  dataGrid: {
    width: "100%",
    minHeight: 500,
    fontSize: 12,
    borderRadius: 0,
    border: 0,
    backgroundColor: "transparent",
    "&.MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
      outline: "none !important",
    },
    "&.MuiDataGrid-root .MuiDataGrid-cell:focus-visible": {
      outline: `2px solid ${theme.palette.primary.main} !important`,
      outlineOffset: "-2px",
    },
    ".MuiDataGrid-cell": {
      display: "flex",
      alignItems: "center",
      borderColor: theme.palette.stroke,
    },
    "& .MuiDataGrid-scrollbar--vertical": {
      display: "none",
    },
    "& .MuiDataGrid-filler": {
      display: "none",
    },
    "& .MuiDataGrid-scrollbarFiller--borderTop": {
      display: "none",
    },
    "& .MuiDataGrid-scrollbarFiller--header": {
      backgroundColor: theme.palette.background.paper,
      borderTop: `1px solid ${theme.palette.stroke}`,
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      color: "text.primary", // Altera a cor do titulo do cabeçalho
    },
    "& .MuiDataGrid-footerContainer": {
      backgroundColor: "transparent", // Altera cor do rodapé
      border: 0,
      borderTop: `1px solid ${theme.palette.stroke}`,
      height: "45px",
    },
    "& .MuiDataGrid-columnHeader": {
      backgroundColor: theme.palette.background.paper, // Altera cor do cabeçalho
      border: 0,
      borderTop: `1px solid ${theme.palette.stroke}`,
      width: "100%",
    },
    "& .MuiDataGrid-topContainer": {
      border: 0,
      backgroundColor: theme.palette.background.paper,
    },
    "& .MuiDataGrid-row--borderBottom": {
      border: 0,
    },
    "& .MuiDataGrid-columnHeaders": {
      border: 0,
      height: "55px",
      backgroundColor: theme.palette.background.paper,
    },

    "& .even-row": { backgroundColor: theme.palette.table },
    "& .odd-row": { backgroundColor: theme.palette.background.paper },
  },

  boxRenderCell: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    height: "100%",
    alignItems: "center",
    gap: 1,
  },
  typography: {
    fontSize: "0.9rem",
  },
  boxButton: { display: "flex", gap: 1 },
  chip: {
    // display: "flex",
    // gap: 1,
    // //flexWrap: "wrap",
    // flexDirection: "row",
    // width: "100%",
    // height: "100%",
    // alignItems: "center",

    fontWeight: 500,
    color: theme.palette.text.primary,
    //padding: "0px 8px",
    height: "28px",
    "& .MuiChip-label": {
      //padding: 0,
    },
    // "& .MuiChip-label": {
    //   fontWeight: 400,
    //   color: theme.palette.text.primary,
    // },
    // "& .MuiChip-root": {
    //   height: "28px",
    // },
  },
  typeDatagrid: {
    display: "flex",
    gap: 1,
    alignItems: "center",
  },
  boxNoRowsOverlay: {
    p: 2,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 1.5,
    height: "100%",
  },
  iconUserNotFound: {
    width: "140px",
    height: "140px",
    fill: theme.palette.text.disabled,
  },
});
